import { Image as ImageIcon } from "lucide-react";

import { cn } from "@/lib/utils";

import type { QuestionRendererProps } from "../types";

const WIDTH_CLASS: Record<"auto" | "full" | "wide" | "narrow", string> = {
  auto: "w-auto max-w-full",
  full: "w-full",
  wide: "w-full max-w-4xl",
  narrow: "w-full max-w-md",
};

const ALIGN_CLASS: Record<"left" | "center" | "right", string> = {
  left: "justify-start",
  center: "justify-center",
  right: "justify-end",
};

export const ImageQuestion = ({ question }: QuestionRendererProps<null>) => {
  if (question.type !== "image") {
    return null;
  }

  const width = question.width ?? "wide";
  const alignment = question.alignment ?? "center";
  const src = question.url?.trim();

  if (!src) {
    return (
      <div className="flex items-center gap-2 rounded-lg border border-dashed border-border/70 bg-muted/20 px-3 py-2 text-sm text-muted-foreground">
        <ImageIcon className="h-4 w-4" />
        <span>No image URL provided.</span>
      </div>
    );
  }

  return (
    <figure className={cn("flex flex-col gap-2", ALIGN_CLASS[alignment])}>
      <img
        src={src}
        alt={question.alt}
        className={cn(
          "rounded-xl border border-border/60 bg-muted/10 object-contain",
          WIDTH_CLASS[width],
        )}
        loading="lazy"
      />
      {question.caption ? (
        <figcaption className="text-xs text-muted-foreground">
          {question.caption}
        </figcaption>
      ) : null}
    </figure>
  );
};
